import { TFunction } from "i18next";
import { lenCheck } from "@/utils/validations/helpers";

export const getAddressValidations = (t: TFunction<"validations">) => ({
  addressPlaceCode: (value: number | null) => (value === null || value === 0 ? t("invalidAddressPlaceCode") : null),
  countryCode: (value: string) => (value === "" ? t("invalidCountryCode") : null),
  street: (value: string) => lenCheck(value, 3, 40, t("requiredStreet"), t("stringTooShort"), t("stringTooLong")),
  streetNumber: (value: string | number) => lenCheck(value, 0, 5, null, t("numberTooShort"), t("numberTooLong")),
  houseNumber: (value: string | number) =>
    lenCheck(value, 0, 5, t("requiredHouseNumber"), t("numberTooShort"), t("numberTooLong")),
  city: (value: string) => lenCheck(value, 0, 20, t("requiredCity"), t("stringTooShort"), t("stringTooLong")),
  cityPart: (value: string) => lenCheck(value, 0, 20, null, t("stringTooShort"), t("stringTooLong")),
  zip: (value: string) => lenCheck(value, 3, 20, t("requiredZip"), t("numberTooShort"), t("numberTooLong")),
  parcelNumber: (value: string | null | undefined) => (value ? null : t("requiredParcelNumber")),
  cadastralTerritoryCode: (value: number | null) => (value ? null : t("requiredCadastralTerritory")),
  productionPointName: (value: string) =>
    lenCheck(value, 1, 64, t("requiredProductionPointName"), t("tooShortProductionPointName"), t("tooLongProductionPointName")),
  customerName: (value: string) =>
    lenCheck(value, 1, 64, t("requiredCustomerName"), t("tooShortCustomerName"), t("tooLongCustomerName")),
});
